module.exports = __webpack_public_path__ + "static/media/LogoWithoutText.63438f5b.svg";